import css from './mapWidget.module.css'
import LinkIcon from '@/assets/icons/externalLink.svg?react'
import Map, { TMapBounds } from '../../../../shared/Map'
import usePersistentState from '@/shared/hooks/usePersistentState'
import { useRecoilValue } from 'recoil'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom'
import { useMemo } from 'react'
import MapEquipmentFilter from '@/pages/DeviceMap/utils/mapEquipmentFilter'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls'
import cn from '@/utils/cn'

const MapWidget = () => {
  const equipmentList = useRecoilValue(equipmentAtom).items
  const [mapBounds, setMapBounds] = usePersistentState<TMapBounds>(null, 'widget/map/mapBounds', 'localstorage')
  const navigate = useNavigate()
  const equipmentFilter = useMemo(() => new MapEquipmentFilter(equipmentList), [equipmentList])

  const equipmentsFittedIntoBounds = useMemo(() => {
    if (!mapBounds) return equipmentList
    return equipmentFilter.getFittedIntoBounds(mapBounds) as IEquipment[]
  }, [mapBounds, equipmentFilter])

  return (
    <div className={css.wrapper}>
      <div className="flex-space-between center" style={{ padding: '4px', paddingLeft: '20px' }}>
        <h2 className="text-heading-4">Карта</h2>
        <div onClick={() => navigate(urls.map)} className={cn('flex-lines center', css.iconContainer)}>
          <LinkIcon />
        </div>
      </div>
      <div className="flex-lines height100 width100">
        <Map
          onResize={setMapBounds}
          mapBounds={mapBounds}
          equipment={equipmentsFittedIntoBounds}
          wrapperStyle={{ borderRadius: '8px' }}
        />
      </div>
    </div>
  )
}

export default MapWidget
